<template>
  <div class="audio">
    <img src="/images/logo-4.png" class="file-icon" />
    <div class="audio-wrap">
      <audio controls :id="mediaData.id">
        <source :src="mediaData.url" :type="`audio/${mediaData.extension}`" />
        <div>
          <span>Формат аудио не поддерживается. </span>
          <a :href="mediaData.url">Скачать</a>.
        </div>
      </audio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioBlock',
  props: {
    mediaData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.audio {
  &-wrap {
    display: block;
    width: 100%;
    height: 220px;
    display: flex;
    align-items: flex-end;
    padding: 10px;
    audio {
      width: 100%;
      object-fit: cover;
    }
  }
  .file-icon {
    width: 242px;
    height: 98px;
    min-width: 242px;
    min-height: 98px;
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
    color: var(--color-white);
  }
}
</style>
